// Timeline rows store dotted event names (case.read, document.uploaded). Rows written before the
// event bus still hold the old snake_case names; every lookup falls back through this map.
// Keep in step with v2api src/models/timeline/eventTypes.ts.
export const LEGACY_TO_NEW = {
  create_case: "case.created",
  view_case: "case.read",
  update_case: "case.updated",
  delete_case: "case.deleted",
  state_change: "case.state.changed",
  create_case_note: "case.note.created",
  update_case_note: "case.note.updated",
  delete_case_note: "case.note.deleted",
  create_document: "document.uploaded",
  update_document: "document.updated",
  delete_document: "document.deleted",
  view_document: "document.viewed",
  download_document: "document.downloaded",
  duplicate_document: "document.duplicated",
  copy_to_document: "document.copied",
  move_to_document: "document.moved",
  create_task: "task.created",
  update_task: "task.updated",
  delete_task: "task.deleted",
  execute_task: "task.executed",
  create_tasklist: "tasklist.created",
  update_tasklist: "tasklist.updated",
  delete_tasklist: "tasklist.deleted",
  start_conversation: "conversation.created",
  reply_to_conversation: "conversation.replied",
  receive_conversation: "conversation.received",
  read_conversation: "conversation.read",
  attach_conversation: "conversation.attached",
  custom: "timeline.custom"
}

export const normaliseEventType = type => (type && LEGACY_TO_NEW[type]) || type

export const eventFamily = type => {
  const normalised = normaliseEventType(type)
  return normalised ? normalised.split(".")[0] : normalised
}

// Returns map[type], falling back to map[LEGACY_TO_NEW[type]] for rows stored with the old name.
export const lookupByEventType = (map, type) => {
  if (!map || !type) {
    return undefined
  }
  if (Object.prototype.hasOwnProperty.call(map, type)) {
    return map[type]
  }
  const mapped = LEGACY_TO_NEW[type]
  if (mapped && Object.prototype.hasOwnProperty.call(map, mapped)) {
    return map[mapped]
  }
  const family = eventFamily(type)
  if (family && Object.prototype.hasOwnProperty.call(map, family)) {
    return map[family]
  }
  return undefined
}

export const isEventType = (activity, type) => normaliseEventType(activity) === type
